import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';

import { logging, logPostInfo } from '../../actions/log';
import SoftTag from '../../components/Forum/SoftTag/SoftTag';
import styles from './CommentList.module.less';
import {
  getForumCommentList,
  setForumCommentLoad,
  setShowForumReview,
  postForumAddZan,
  setForumCommentCollpase,
} from '../../actions/forum';
import dayjs from 'dayjs';
import InfiniteScroll from 'react-infinite-scroller';
import UserHeader from '../../static/forum_default_header.svg';
import { formatNumber } from '../../utils/utils';
import Rate from '../Rate/Rate';
import CoolLogo from '../../static/forum_logo.svg';
import { CONTEXT } from '../../config';
import { useHistory } from 'react-router';
import { useActivate } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
function CommentList(props) {
  const dispatch = useDispatch();
  const { forumCommentList } = useSelector(selectForum);
  const {
    commentId,
    hasScore,
    scrollEl = document.getElementById('container_content'),
    type, // 1-应用评论  2-专题评论  3-帖子评论
    relaseId,
    logInfo = {},
    forum,
  } = props;
  const logInfoData = useSelector(selectLogInfo);
  const history = useHistory();
  const userInfo = useSelector(selectUserInfo);
  const [hasZanEvent, setHasZanEvent] = useState(null);

  useEffect(() => {
    if (commentId) {
      const params = {
        bizIdentity: commentId,
        startIndex: 1,
        count: 24,
        orderBy: 'DATE',
        refresh: true,
      };
      dispatch(getForumCommentList(params));
    }
  }, [commentId, userInfo]);
  useActivate(() => {
    if (
      !forumCommentList ||
      !forumCommentList.dataList ||
      !forumCommentList.dataList[0] ||
      commentId !==
        (forumCommentList.dataList[0].comment && forumCommentList.dataList[0].comment.bizIdentity)
    ) {
      if (commentId) {
        const params = {
          bizIdentity: commentId,
          startIndex: 1,
          count: 24,
          orderBy: 'DATE',
          refresh: true,
        };
        dispatch(getForumCommentList(params));
      }
    }
  });

  const loadMore = () => {
    if (
      commentId &&
      !forumCommentList.loading &&
      forumCommentList.dataList.length < forumCommentList.totalCount
    ) {
      dispatch(setForumCommentLoad(true));
      const params = {
        bizIdentity: commentId,
        startIndex: forumCommentList.dataList.length + 1,
        count: 24,
        orderBy: 'DATE',
        refresh: false,
      };
      dispatch(getForumCommentList(params));
    }
  };
  const handleReview = useCallback(
    comment => {
      dispatch(setShowForumReview({ ...comment, forumId: commentId }));
    },
    [commentId],
  );

  const handleZan = ({ comment }) => () => {
    const loginStatus = window.CallNativeMethod && window.CallNativeMethod('get_login_status');
    if (loginStatus === '1' && userInfo.st) {
      setHasZanEvent(null);
      dispatch(
        logging({
          category: 'C',
          action: 'Detail_CommmentZan',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: commentId,
            commmentId: comment.id,
          },
        }),
      );
      dispatch(
        postForumAddZan({
          originalCommentId: comment.id,
          type,
          commentUserId: comment.userId,
          bizId: commentId,
        }),
      );
    } else {
      setHasZanEvent({ comment });
      // eslint-disable-next-line no-unused-expressions
      window.CallNativeMethod && window.CallNativeMethod('login');
    }
  };

  useEffect(() => {
    if (hasZanEvent) {
      const loginStatus = window.CallNativeMethod && window.CallNativeMethod('get_login_status');
      if (loginStatus === '1' && userInfo.st) {
        handleZan(hasZanEvent)();
      }
    }
  }, [userInfo, hasZanEvent]);

  const handleForum = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'AppDetail_Comment_Forum',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          id: relaseId,
          softType: '0',
          forumId: forum && forum.content && forum.content.id,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (forum && forum.content && forum.content.id) {
      history.push(`${CONTEXT}/forumdetail?id=${forum.content.id}`);
    } else {
      history.push(`${CONTEXT}/forumlist`);
    }
  };

  const ChildComment = ({ comment = {}, lastChild, firstChild }) => {
    let replyUser = '';
    let replyContent = comment.content;
    if (comment.content && comment.content.indexOf('@') > -1) {
      const content = comment.content.replace('@', '');
      const index = content.indexOf(':');
      if (comment.originalCommentId !== comment.parentId) {
        replyUser = content.slice(0, index);
      }
      replyContent = content.slice(index + 1);
    }

    return (
      <div
        className={`${styles.child_comment} ${lastChild ? styles.child_comment_space : ''} ${
          firstChild ? styles.child_comment_space_top : ''
        }`}
      >
        <div className={styles.child_comment_left}>
          <img src={comment.headUrl || UserHeader} className={styles.child_comment_img} />
        </div>
        <div className={styles.child_comment_right}>
          <div className={styles.user_container}>
            <div className={styles.user}>
              {comment.userName}

              {/* {replyUser && <img src={ForumReply} className={styles.icon}></img>} */}
              {replyUser && '  回复  '}
              {replyUser ? `${replyUser}` : ''}
            </div>
            <div className={styles.reply_time}>
              {comment.createDate ? dayjs(comment.createDate).format('YYYY-MM-DD HH:mm') : '刚刚'}
            </div>
          </div>
          <div className={styles.content_container}>
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: replyContent.split('\n').join('<br/>') }}
            />
          </div>
          {comment.passInfos && comment.passInfos.length > 0 && (
            <div className={styles.tag}>
              <SoftTag
                forumData={{ passInfos: comment.passInfos }}
                logInfo={{ source: 'Forum_Detail' }}
              />
            </div>
          )}
        </div>
        <div
          className={styles.reply}
          onClick={() => {
            handleReview(comment);
          }}
        >
          回复
        </div>
      </div>
    );
  };
  const CommentItem = ({ commentInfo = {}, dataIndex }) => {
    const limit = 3;
    // const [collapse, setCollapase] = useState(true);
    if (!commentInfo) {
      return null;
    }
    const { comment = {}, replys = [] } = commentInfo;
    return (
      <div className={styles.comment_item}>
        <div className={styles.comment_user}>
          <img className={styles.comment_img} src={comment.headUrl || UserHeader} />
          <div className={styles.comment_content}>
            <div className={styles.comment_top}>
              <div className={styles.comment_top_left}>
                <div className={styles.comment_top_user}>{comment.userName}</div>
              </div>

              <div className={styles.comment_top_time}>
                {(comment.createDate && dayjs(comment.createDate).format('YYYY-MM-DD HH:mm')) || ''}
              </div>
              <div className={styles.comment_top_model}>{comment.model}</div>
              {commentInfo.hot && <div className={styles.comment_top_tag}>热门评论</div>}
            </div>
            <div className={styles.comment_container}>
              <div
                className={styles.comment_text}
                dangerouslySetInnerHTML={{ __html: comment.content.split('\n').join('<br/>') }}
              />
              {/* </div> */}
            </div>
          </div>
          <div className={styles.comment_operation}>
            {hasScore && (
              <div className={styles.comment_opt_rate}>
                <Rate score={comment.grade} />
              </div>
            )}

            <div className={styles.comment_opt}>
              <div className={styles.comment_opt_item} onClick={handleZan(commentInfo)}>
                <i
                  className={`${styles.comment_opt_cion} iconfont ${
                    commentInfo.hasZan === 1 ? 'icon-zaned' : 'icon-zan'
                  }`}
                />
                <div className={styles.comment_opt_num}>
                  {formatNumber(commentInfo.zanCounter || 0)}
                </div>
              </div>
              <div
                className={styles.comment_opt_item}
                onClick={() => {
                  handleReview(commentInfo.comment);
                }}
              >
                <i className={`${styles.comment_opt_cion} iconfont icon-fcomment`} />
                <div className={styles.comment_opt_num}>回复</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.comment_reply}>
          {comment.passInfos && comment.passInfos.length > 0 && (
            <div className={styles.comment_tag}>
              <SoftTag
                forumData={{ passInfos: comment.passInfos }}
                logInfo={{ source: 'Forum_Detail' }}
              />
            </div>
          )}
          {(!commentInfo.open ? replys.slice(0, limit) : replys).map((item, index) => (
            <ChildComment
              comment={item}
              key={item.id}
              parentId={comment.id}
              lastChild={index === replys.length - 1}
              firstChild={index === 0}
            />
          ))}
          {replys.length > limit && !commentInfo.open && (
            <div
              className={styles.reply}
              onClick={() => {
                // setCollapase(false);
                dispatch(
                  setForumCommentCollpase({
                    index: dataIndex,
                    hot: commentInfo.hot,
                  }),
                );
              }}
            >
              查看全部{replys.length}条回复
              <i className={`iconfont icon-point_right ${styles.reply} ${styles.reply_icon}`} />
            </div>
          )}
        </div>
      </div>
    );
  };
  if (
    !forumCommentList ||
    !forumCommentList.dataList ||
    !forumCommentList.dataList[0] ||
    commentId !==
      (forumCommentList.dataList[0].comment && forumCommentList.dataList[0].comment.bizIdentity)
  ) {
    return null;
  }
  return (
    <div className={styles.comment}>
      <div className={styles.comment_header}>
        <div className={styles.comment_header_icon} />
        <div className={styles.comment_header_text}>网友评论</div>
        <div className={styles.comment_header_total}>（{forumCommentList.totalCount}条）</div>
      </div>

      {/* 7.5 酷软圈改版，取消掉老版本酷软圈入口  */}
      {false && forum && forum.hasForum && (
        <div className={styles.advert} onClick={handleForum}>
          <div className={styles.advert_logo}>
            <img src={CoolLogo} alt="" />
          </div>
          <div className={styles.advert_desc}>
            <div className={styles.advert_desc_text}>
              {' '}
              {forum.content && forum.content.title
                ? `#${forum.content.title}`
                : `想对 ${forum.softName} 分享或提问？去酷软圈论坛畅所欲言～`}
            </div>
            <div className={styles.advert_btn}>去看看</div>
          </div>
        </div>
      )}

      {forumCommentList.dataList.length > 0 && (
        <div className={styles.comment_list}>
          <InfiniteScroll
            pageStart={1}
            loadMore={loadMore}
            hasMore={forumCommentList.dataList.length < forumCommentList.totalCount}
            loader={
              <div className="loader" key={0}>
                ----------加载中----------
              </div>
            }
            initialLoad={false}
            useWindow={false}
            getScrollParent={() => scrollEl}
          >
            <div className={styles.content}>
              {[...(forumCommentList.hotdatalist || [])].map((item, index) => {
                return (
                  <CommentItem
                    commentInfo={item}
                    key={`${item.comment.id}_hot`}
                    dataIndex={index}
                  />
                );
              })}
              {[...forumCommentList.dataList].map((item, index) => {
                return <CommentItem commentInfo={item} key={item.comment.id} dataIndex={index} />;
              })}
            </div>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}

export default props => {
  return <CommentList {...props} />;
};
